import { ModelCommon, UserAttributeDef, UserAttributeDefs, toDatePickerFormat, ValidModelType, Device } from '@iotv/datamodel-core';
import { isValidBusinessObject, MapLike, PathDirection } from '@iotv/iotv-v3-types';

const typeName = 'IrrigationDeviceConfig';

export type IrrigationDeviceConfigProps = {
  qRCode?: string;
  network?: string;
  status?: string;
  accelerometerThreshold?: number;
  immediateButtonTime?: number;
  valveOffPulse?: number;
  valveOnPulse?: number;
  error?: string;
  temperature?: number;
  moisture?: number;
  systemTime?: number;
  voltage?: number;
  boostVoltage?: number;
  signal_snr?: string;
  signal_rssi?: string;
  optionsMask?: string;
  sentProgramme?: string;
  currentProgramme?: string;
  expectedPayload?: string;
  sentPayloads?: string[];
  gateway?: string;
  linkMargin?: number;
  app_cycle_time?: number;
  sys_cycle_time?: number;
};

export class IrrigationDeviceConfig extends Device {
  constructor(ob: any) {
    super({ type: typeName, ...ob });
  }

  isProvisioned?: string;
  qRCode?: string;
  network?: string;
  status?: string;
  accelerometerThreshold?: number;
  immediateButtonTime?: number;
  valveOffPulse?: number;
  valveOnPulse?: number;
  error?: MapLike<0|1>;
  temperature?: number;
  moisture?: number;
  systemTime?: number;
  voltage?: number;
  boostVoltage?: number;
  signal_snr?: string;
  signal_rssi?: string;
  optionsMask?: string;
  sentProgramme?: string;
  currentProgramme?: string;
  expectedPayload?: string;
  sentPayloads?: string[];
  gateway?: string;
  linkMargin?: number;
  app_cycle_time?: number;
  sys_cycle_time?: number;

}
